export default {
    script_id:'google-jssdk',
    src:'https://accounts.google.com/gsi/client',    
    client_id:'798429865723-pvb18k47pdjt0dgcs8b86fqv61ibtcpe.apps.googleusercontent.com',    
    context      : 'signin',
    itp_support    : 'true',
    onload:true,
    callback:'galogin_callback',
    id:'g_id_onload'
}